import { defineComponent as _defineComponent } from 'vue'
import { RegistrationStepKeys } from '@/app/helpers/registration/flow';
import { ref } from 'vue';
import OnboardingReview from './OnboardingReview.vue';
import SignatoryTermsReview from './forms/SignatoryTermsReview.vue';
import { Client } from 'ah-api-gateways';


export default /*#__PURE__*/_defineComponent({
  __name: 'OwnerReview',
  props: {
    client: null
  },
  emits: ["flow-finished", "update:client"],
  setup(__props: any, { emit }: { emit: ({ (e: 'flow-finished'): void; (e: 'update:client', value: Client): void }), expose: any, slots: any, attrs: any }) {



const step = ref<'review' | 'terms'>('review');



function finish() {
  emit('flow-finished');
}

return { __sfc: true,step, emit, finish, RegistrationStepKeys, OnboardingReview, SignatoryTermsReview }
}

})